var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:`playlist_video_${_vm.slide.item_id}`,staticClass:"playlist-slide-video",style:(_vm.videoStyle),attrs:{"loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.getEncodedURL(_vm.baseUrl, _vm.slide.item_url),"type":_vm.slide.item_type}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }